import * as React from 'react'
import { ReactElement } from 'react'
import { Textarea, TextareaProps } from '@fluentui/react-components'
import FormikField, { FormikSubFieldProps } from './FormikField'

export default function FormikTextareaField<Values>(props: FormikSubFieldProps<TextareaProps, Values>): ReactElement {
    return (
        <FormikField<TextareaProps, Values>
            component={Textarea}
            {...props}
            componentProps={{ rows: 3, resize: 'vertical', ...props.componentProps }}
        />
    )
}
